module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AWz"
    }
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz11-3"
    }
  }, [_c('b', [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("D")])]), _vm._v("uring Jesus’ time in the wilderness, Satan tempted Jesus by offering Him all the kingdoms of the world . . . "), _c('i', [_vm._v("if")]), _vm._v(" Jesus would fall down and worship him. Turning to God’s Word and allowing it to guide His choice, Jesus said, “It is written.” Jesus spoke aloud God’s command—”You shall worship the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God”—thereby ending His conversation with Satan. Jesus had overcome all of Satan’s temptations by quoting the Scriptures. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz11-4"
    }
  }, [_vm._v("Consider the items you are tempted to worship. The list of items that come to mind may seem full of clichés, but try not to dismiss them. Each one has the ability to attract your worship. What does the world invite you to worship? The world encourages you to set up an altar to—among other things—self, family, money, possessions, and status. When one of those temptations beckons you, try to follow Jesus’ example. Choose to say aloud and boldly, “It is written, ‘You shall worship the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God, and Him only you shall serve.’ ” Trust that the temptation will abate just as it did in Jesus’ case. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba4235e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter06.vue
// module id = 81
// module chunks = 0